import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BlockServiceAction, BlockServiceReasonAction } from "../../redux/Action/Availability";
import Spinner from "../Spinner";
import { capitalizeFirstLetter, handleInput } from "../../utils/Helper";
import $ from "jquery"
import Button from "../Ui/Button";
import { DashboardBookingChangeUpdateAction } from "../../redux/Action/DashboardAction";
import { FormattedMessage, useIntl } from "react-intl";
const CancelReason = ({ status, setCancelStatus, payload }: any) => {
    const intl = useIntl();
    const dispatch = useDispatch<any>();
    const [cancelReason, setCancelReason] = useState("");
    const block_service_close_reason = useSelector((state: any) => state.BlockServiceReasonState);
    const [selectedReason, setSelectedReason]: any = useState(null);
    const [selectedReasonError, setSelectedReasonError]: any = useState('');

    const dashboard_booking_accept_cancel_change = useSelector((state: any) => state.DashboardBookingStatusChangeBookingState);


    const handleRadioChange = (e: any) => {
        setSelectedReason(e.target.value);
    };

    useEffect(() => {
        if (block_service_close_reason?.status) {
            setSelectedReason(block_service_close_reason?.data?.data?.[0]?.title)
        }
    }, [block_service_close_reason])


    useEffect(() => {
        if (status) {
            dispatch(BlockServiceReasonAction({ attrib_type: 2 }))
        }
    }, [status]);

    useEffect(() => {
        if (cancelReason.length > 0) {
            setSelectedReasonError('')
        }
    }, [cancelReason])

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (cancelReason?.length == 0) {
            setSelectedReasonError('Please select a reason')
            return;
        }
        setSelectedReasonError("")
        const data = {
            ...payload,
            booking_status: payload?.tabName,
            reason: "REASON  BOOKING",
            reason_type: cancelReason
        }

        dispatch(DashboardBookingChangeUpdateAction(data))
    }

    useEffect(() => {
        if (dashboard_booking_accept_cancel_change?.status) {
            $(".btnClose").click()
            $('.modal-backdrop').remove();
            dispatch(BlockServiceAction("RESET"))
            dispatch(BlockServiceReasonAction("RESET"))
            dispatch(DashboardBookingChangeUpdateAction("RESET"))
            setSelectedReason(block_service_close_reason?.data?.data?.[0]?.title)
            setCancelReason("")
            setCancelStatus(false)

        }
    }, [dashboard_booking_accept_cancel_change])

    useEffect(() => {
        return () => {
            dispatch(BlockServiceAction("RESET"))
            dispatch(BlockServiceReasonAction("RESET"))
            $('.modal-backdrop').remove();
            dispatch(DashboardBookingChangeUpdateAction("RESET"))
            setSelectedReason(block_service_close_reason?.data?.data?.[0]?.title)
            setCancelReason("")
            setCancelStatus(false)
        }
    }, [])

    const handleClose = () => {
        $(".btnClose").click()
        dispatch(BlockServiceAction("RESET"))
        dispatch(BlockServiceReasonAction("RESET"))
        setSelectedReason(block_service_close_reason?.data?.data?.[0]?.title)
        setCancelReason("")
        setCancelStatus(false)
    }
    return (
        <>
            <div className="modal modelStyle fade" id="cancelReason" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        {/* {block_service_close_reason?.loading || add_block_service?.loading ? <Spinner /> : ""} */}
                        <div className="modal-header">
                            <h1 className="modal-title fs-5"><FormattedMessage id="cancel_reason" /></h1>
                            <button type="button" className="btn p-0 f-20 btnClose" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}><span className="icon-close"></span></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                {
                                    block_service_close_reason?.data?.data?.map((item: any, index: any) => {
                                        return (
                                            <>

                                                <div className="form-check mb-3">
                                                    <input type="radio" className="form-check-input" name="optradio"
                                                        value={item?.title ? capitalizeFirstLetter(item?.title) : ""}
                                                        id={`radio${index}`}
                                                        checked={selectedReason == item?.title}
                                                        onChange={handleRadioChange}

                                                    />{item?.title}
                                                    <label className="form-check-label" htmlFor="radio1"></label>
                                                </div>
                                            </>
                                        )
                                    })
                                }

                                <div className='mb-3'>
                                    <textarea className="form-control" id="comment" name="text"  
                                    placeholder={intl.formatMessage({ id: 'write_your_reason' })}
                                    value={cancelReason}
                                        onInput={(e: any) => {
                                            const value = e.target.value.replace(/\s{2,}/g, ' ');
                                            setCancelReason(value)
                                        }}
                                        maxLength={100}
                                    ></textarea>
                                    {selectedReasonError && <p className="text-danger">{selectedReasonError}</p>}
                                </div>
                                <Button text= {intl.formatMessage({ id: 'submit' })} type='submit' className="btn btn-fill w-100" isLoading={dashboard_booking_accept_cancel_change?.loading} />
                                {/* <button type='submit' className="btn btn-fill w-100" >Submit</button> */}
                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default CancelReason;